module.exports = __webpack_public_path__ + "static/media/blog-brexit-and-uk-agrifood@2x.0880ee40.jpg";